
import Home from "@/pages/Home";

const Index = () => {
  return (
    <Home />
  );
};

export default Index;
